/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimSharedFilterOption } from './ClaimSharedFilterOption';
import {
    ClaimSharedFilterOptionFromJSON,
    ClaimSharedFilterOptionFromJSONTyped,
    ClaimSharedFilterOptionToJSON,
    ClaimSharedFilterOptionToJSONTyped,
} from './ClaimSharedFilterOption';

/**
 * 
 * @export
 * @interface GetSharedClaimFilterOptions200Response
 */
export interface GetSharedClaimFilterOptions200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetSharedClaimFilterOptions200Response
     */
    success: boolean;
    /**
     * 
     * @type {Array<ClaimSharedFilterOption>}
     * @memberof GetSharedClaimFilterOptions200Response
     */
    data: Array<ClaimSharedFilterOption>;
}

/**
 * Check if a given object implements the GetSharedClaimFilterOptions200Response interface.
 */
export function instanceOfGetSharedClaimFilterOptions200Response(value: object): value is GetSharedClaimFilterOptions200Response {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetSharedClaimFilterOptions200ResponseFromJSON(json: any): GetSharedClaimFilterOptions200Response {
    return GetSharedClaimFilterOptions200ResponseFromJSONTyped(json, false);
}

export function GetSharedClaimFilterOptions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSharedClaimFilterOptions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'data': ((json['data'] as Array<any>).map(ClaimSharedFilterOptionFromJSON)),
    };
}

export function GetSharedClaimFilterOptions200ResponseToJSON(json: any): GetSharedClaimFilterOptions200Response {
    return GetSharedClaimFilterOptions200ResponseToJSONTyped(json, false);
}

export function GetSharedClaimFilterOptions200ResponseToJSONTyped(value?: GetSharedClaimFilterOptions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': ((value['data'] as Array<any>).map(ClaimSharedFilterOptionToJSON)),
    };
}

